export const landingTranslations = {
  en: {
    landingBrandSubtitle: "Better weather near campsites in Iceland",
    landingNavHow: "How it works",
    landingNavWhy: "Why",
    landingNavScreenshots: "Screenshots",
    landingOpenCampcast: "Check weather now",

    landingEyebrow: "Built for Iceland camping, caravans, campervans, and tents.",
    landingHeroTitle: "Avoid the worst camping weather in Iceland",
    landingHeroSubtitle:
      "Compare nearby campsites, check wind and rain risks, and see when moving could give you better conditions.",
    landingPrimaryCta: "Find better weather nearby",
    landingSecondaryCta: "See how it works",

    landingStat1Label: "For campers / vans",
    landingStat1Value: "Avoid strong wind at your campsite",

    landingStat2Label: "Nearby comparison",
    landingStat2Value: "See where it is calmer",

    landingStat3Label: "Better decisions",
    landingStat3Value: "Know if moving is worth it",

    landingHeroMockTitle: "See where the weather is better nearby",
    landingHeroMockSubtitle: "A clear view of whether staying or moving makes more sense.",

    landingProblem1Title: "Bad weather can ruin the trip",
    landingProblem1Text:
      "Wind, rain, and exposure can turn a good plan into a bad night very quickly.",
    landingProblem2Title: "A normal forecast is not always enough",
    landingProblem2Text:
      "You do not just need the weather. You need to know if a nearby campsite is a better option.",
    landingProblem3Title: "Chase the Weather helps you choose better",
    landingProblem3Text:
      "Compare campsite conditions and decide whether to stay or move before you drive.",

    landingHowEyebrow: "How it works",
    landingHowTitle: "Avoid bad weather in seconds",
    landingHowText:
      "Compare nearby campsites and avoid wind, rain, and bad conditions before you move.",
    landingStepLabel: "Step",
    landingStep1Title: "Start where you are or choose a campsite",
    landingStep1Text: "Start from your location or browse campsites nearby.",

    landingStep2Title: "See where conditions are better nearby",
    landingStep2Text:
      "See where wind, rain, and overall conditions look better over the next days.",

    landingStep3Title: "Stay or move based on conditions",
    landingStep3Text: "Stay or move if a better option is nearby.",

    landingWhyEyebrow: "Why",
    landingWhyTitle: "A forecast is not enough in Iceland",
    landingWhyText:
      "A normal forecast tells you what the weather will be. Chase the Weather helps you decide where it is best to be.",

    landingCompareHeaderLeft: "Typical weather app",
    landingCompareHeaderRight: "Chase the Weather",
    landingCompareLeft1: "Shows one forecast",
    landingCompareRight1: "Shows where it is better nearby",
    landingCompareLeft2: "Tells you what weather is coming",
    landingCompareRight2: "Helps you decide if moving makes sense",
    landingCompareLeft3: "Generic location forecast",
    landingCompareRight3: "Built around campsites in Iceland",

    landingBenefit1Title: "Avoid rough conditions",
    landingBenefit1Text: "Quickly spot wind, gusts, and rain that can affect your stay.",
    landingBenefit2Title: "Made for campsite decisions",
    landingBenefit2Text:
      "Not a generic weather app. Chase the Weather helps you compare real options nearby.",
    landingBenefit3Title: "Built for Icelandic conditions",
    landingBenefit3Text: "Designed for road trips, changing forecasts, and exposed campsites.",

    landingScreenshotsEyebrow: "Examples",
    landingScreenshotsTitle: "See where it is better to be",
    landingScreenshotsText: "Chase the Weather shows whether you should stay, consider moving, or move.",
    landingScreenshot1Title: "See conditions near your campsite",
    landingScreenshot1Subtitle:
      "See conditions where you are and whether a better option is nearby.",
    landingScreenshot2Title: "Find better weather nearby",
    landingScreenshot2Subtitle: "See where conditions are better instead of guessing.",
    landingScreenshot3Title: "Decide if moving is worth it",
    landingScreenshot3Subtitle: "See whether moving is worth it before you continue your trip.",

    landingFinalEyebrow: "Planning to camp in Iceland?",
    landingFinalTitle: "Find better weather before you go",
    landingFinalText:
      "Compare nearby campsite conditions and avoid getting stuck in bad wind, rain, or exposed locations.",
    landingFinalNote: "No signup required.",

    landingMockTagline: "Better weather near campsites in Iceland",
    landingMockBetterNearby: "Better nearby",
    landingMockCurrentCampsite: "Vík Campsite",
    landingMockCurrentRegion: "South Iceland",
    landingMockScore: "Score",
    landingMockWind: "Wind",
    landingMockRain: "Rain",
    landingMockTrend: "Trend",
    landingMockTrendRough: "Rough",
    landingMockRecommendationTitle1: "Better option nearby",
    landingMockRecommendationTitle2: "Try this instead",
    landingMockRecommendationTitle3: "Weather looks better here",
    landingMockBetterPlace: "Þakgil",
    landingMockBetterDistance: "24 km away",
    landingMockBenefit1: "Lower wind exposure",
    landingMockBenefit2: "Less rain tomorrow",
    landingMockBenefit3: "Better overall camping conditions",
    landingAdvisorModuleTitle: "Route Advisor",
    landingAdvisorModuleSubtitle: "Find better weather nearby before you move.",

    landingAdvisorBadgeStay: "Stay",
    landingAdvisorBadgeConsider: "Consider moving",
    landingAdvisorBadgeMove: "Move",

    landingAdvisorStayTitle: "Stay",
    landingAdvisorStaySubtitle: "Conditions here are acceptable over the next days",
    landingAdvisorStayBenefit1: "Small changes ahead",
    landingAdvisorStayBenefit2: "Conditions are manageable",
    landingAdvisorStayBenefit3: "No clear benefit in moving",

    landingAdvisorConsiderTitle: "Consider moving",
    landingAdvisorConsiderSubtitle: "Better conditions are available nearby",
    landingAdvisorConsiderBenefit1: "Lower wind exposure elsewhere",
    landingAdvisorConsiderBenefit2: "Less rain nearby",
    landingAdvisorConsiderBenefit3: "Moving could be worth it",

    landingAdvisorMoveTitle: "Move",
    landingAdvisorMoveSubtitle: "Moving is worth it based on the conditions",
    landingAdvisorMoveBenefit1: "Less wind exposure",
    landingAdvisorMoveBenefit2: "Less rain tomorrow",
    landingAdvisorMoveBenefit3: "Better overall camping conditions",

    landingAdvisorStayRisk: "Current status: Manageable",
    landingAdvisorStayExtra: "There is no need to move right now.",

    landingAdvisorConsiderRisk: "Current status: Changing",
    landingAdvisorConsiderExtra: "Better conditions are nearby — moving could be worth it",

    landingAdvisorMoveRisk: "Route risk: Medium",
    landingAdvisorMoveExtra: "A longer storm period is likely on Route 1 toward Laugardalur.",

    landingHeroUrgency: "In Iceland, the weather 20 minutes away can be completely different.",
    landingHeroNoSignup: "No signup required",
    landingFinalCta: "Check weather near you",

    comparisonSectionTitle: "Better weather may be closer than you think",
    comparisonSectionSubtitle:
      "Chase the Weather compares nearby campsites to help you spot calmer, drier, and more comfortable options.",
    comparisonCurrentLabel: "Current campsite",
    comparisonBetterLabel: "Nearby alternative",

    comparisonRowGust: "Gusts",
    comparisonRowRain: "Rain",
    comparisonRowConditions: "Conditions",
    comparisonRowWarnings: "Warnings",

    comparisonCurrentGust: "20 m/s",
    comparisonCurrentRain: "Heavy",
    comparisonCurrentConditions: "Difficult",
    comparisonCurrentWarnings: "2 active",

    comparisonBetterGust: "10 m/s",
    comparisonBetterRain: "Light",
    comparisonBetterConditions: "Manageable",
    comparisonBetterWarnings: "None",

    comparisonLessWind: "Lower wind exposure",
    comparisonLessRain: "Less rain",
    comparisonBetterComfort: "More comfortable conditions",
    comparisonFewerWarnings: "Fewer weather warnings",
    comparisonBetterDriving: "Better driving conditions",

    campaignAvoidBadWeatherHeadline: "Avoid the worst camping weather in Iceland",
    campaignAvoidBadWeatherSubheadline: "Compare nearby campsites and spot calmer, drier options before you settle in.",
    campaignAvoidBadWeatherCta: "Find better weather nearby",

    campaignCaravanWeatherHeadline: "Plan calmer campsite moves with your caravan",
    campaignCaravanWeatherSubheadline: "Check wind, gusts, rain, and nearby alternatives before towing or parking up.",
    campaignCaravanWeatherCta: "Compare caravan conditions",

    campaignCampingWindHeadline: "Check wind and gusts before choosing a campsite",
    campaignCampingWindSubheadline: "Spot exposed campsites and find calmer nearby options for tents, campervans, and caravans.",
    campaignCampingWindCta: "Find calmer campsites nearby",

    campaignWeekendCampingHeadline: "Find better camping weather for the weekend",
    campaignWeekendCampingSubheadline: "Compare nearby campsites before leaving so wind or rain does not catch you out.",
    campaignWeekendCampingCta: "Plan this weekend",

    // Ticket 399 (#399) — /en/northern-lights, a permanent English-only
    // product-entry page. Route-locked to English (useT("en") at the route
    // boundary), so the "is" companion values below exist only to satisfy
    // this file's established translation-shape convention and are never
    // actually rendered by that route.
    // Ticket 403 (#403): hero/metadata revised to sell the real WHERE-to-go
    // value proposition — never a claimed best viewing time/window/peak
    // time (approved prompt §1's explicit prohibition).
    auroraLandingMetaTitle: "Where to See the Northern Lights in Iceland Tonight",
    auroraLandingMetaDescription:
      "Compare aurora activity and cloud conditions across locations in Iceland to find out where to go for the Northern Lights tonight.",
    auroraLandingHeroTitle: "Find where to see the Northern Lights in Iceland tonight",
    auroraLandingHeroSubtitle:
      "We compare aurora activity and cloud conditions across locations in Iceland to help you decide where to go.",
    // Ticket 403: Free-only conversion section heading, below the card.
    auroraLandingValueSectionHeading: "Know where to go tonight",
    auroraLandingHowEyebrow: "How it works",
    auroraLandingHowText:
      "Current viewing conditions are compared across Iceland using aurora activity, cloud conditions, and darkness.",
    auroraLandingDisclaimer:
      "The Northern Lights are a natural phenomenon. No forecast can guarantee visibility.",
  },

  is: {
    landingBrandSubtitle: "Veður í nágrenni tjaldsvæða á Íslandi",
    landingNavHow: "Hvernig virkar þetta",
    landingNavWhy: "Af hverju",
    landingNavScreenshots: "Skjáskot",
    landingOpenCampcast: "Opna Eltum Veðrið",

    landingEyebrow: "Hannað fyrir tjaldsvæði, húsbíla, hjólhýsi og tjöld á Íslandi.",
    landingHeroTitle: "Forðastu versta tjaldveðrið á Íslandi",
    landingHeroSubtitle:
      "Berðu saman nálæg tjaldsvæði, skoðaðu vind og rigningu og sjáðu hvenær betra veður gæti verið í nágrenninu.",
    landingPrimaryCta: "Finna betra veður í nágrenninu",
    landingSecondaryCta: "Hvernig þetta virkar",

    landingStat1Label: "Fyrir camper / hjólhýsi",
    landingStat1Value: "Forðastu slæmt veður",

    landingStat2Label: "Rauntíma samanburður",
    landingStat2Value: "Sjáðu hvar það er betra",

    landingStat3Label: "Betri ákvarðanir",
    landingStat3Value: "Færðu þig ef það borgar sig",

    landingHeroMockTitle: "Sjáðu hvar veðrið er betra í nágrenninu",
    landingHeroMockSubtitle: "Skýr sýn á hvort sé betra að vera áfram eða færa sig.",

    landingProblem1Title: "Slæmt veður getur eyðilagt ferðina",
    landingProblem1Text:
      "Vindur, rigning og berskjölduð staðsetning geta breytt góðri áætlun í slæma nótt mjög hratt.",
    landingProblem2Title: "Venjuleg veðurspá dugar ekki alltaf",
    landingProblem2Text:
      "Þú þarft ekki bara að sjá veðrið. Þú þarft að vita hvort annað tjaldsvæði í nágrenninu sé betri kostur.",
    landingProblem3Title: "Eltum Veðrið hjálpar þér að velja betri kost",
    landingProblem3Text:
      "Berðu saman aðstæður á tjaldsvæðum og taktu betri ákvörðun áður en þú keyrir af stað.",

    landingHowEyebrow: "Hvernig virkar þetta",
    landingHowTitle: "Finndu betri stað á nokkrum sekúndum",
    landingHowText: "Berðu saman veður í nágrenninu og sjáðu hvort borgi sig að færa sig.",
    landingStepLabel: "Skref",
    landingStep1Title: "Byrjaðu þar sem þú ert eða veldu tjaldsvæði",
    landingStep1Text: "Byrjaðu þar sem þú ert eða skoðaðu tjaldsvæði í nágrenninu.",
    landingStep2Title: "Berðu saman veður í nágrenninu",
    landingStep2Text: "Sjáðu hvar vindur, rigning og heildaraðstæður líta betur út næstu daga.",
    landingStep3Title: "Veldu betri stað",
    landingStep3Text: "Vertu áfram eða færðu þig ef betri kostur er í nágrenninu.",

    landingWhyEyebrow: "Af hverju",
    landingWhyTitle: "Ekki bara veður – sjáðu hvar er betra að vera",
    landingWhyText:
      "Venjuleg veðurspá segir þér hvernig veðrið verður. Eltum Veðrið hjálpar þér að velja hvar er best að vera.",

    landingCompareHeaderLeft: "Venjulegt veðurapp",
    landingCompareHeaderRight: "Eltum Veðrið",
    landingCompareLeft1: "Sýnir eina veðurspá",
    landingCompareRight1: "Sýnir þér hvar er betra að vera",
    landingCompareLeft2: "Segir þér hvernig veðrið verður á einum stað",
    landingCompareRight2: "Hjálpar þér að ákveða hvort sé skynsamlegt að færa sig",
    landingCompareLeft3: "Almenn spá fyrir staðsetningu",
    landingCompareRight3: "Byggt utan um tjaldsvæði á Íslandi",

    landingBenefit1Title: "Forðastu slæmar aðstæður",
    landingBenefit1Text: "Sjáðu fljótt vind, hviður og rigningu sem geta haft áhrif á dvölina.",
    landingBenefit2Title: "Gert fyrir ákvarðanir um tjaldsvæði",
    landingBenefit2Text:
      "Ekki bara almennt veðurapp. Eltum Veðrið hjálpar þér að bera saman raunverulega valkosti í nágrenninu.",
    landingBenefit3Title: "Byggt fyrir íslenskar aðstæður",
    landingBenefit3Text:
      "Hannað með íslenskar bílferðir, breytilegar spár og berskjölduð tjaldsvæði í huga.",

    landingScreenshotsEyebrow: "Skjáskot",
    landingScreenshotsTitle: "Sjáðu hvar er betra að vera",
    landingScreenshotsText:
      "Eltum Veðrið sýnir þér hvort þú ættir að vera áfram, íhuga að færa þig eða færa þig.",
    landingScreenshot1Title: "Sjáðu aðstæður við tjaldsvæðið þitt",
    landingScreenshot1Subtitle: "Sjáðu aðstæður þar sem þú ert og hvort betri kostur sé nálægt.",
    landingScreenshot2Title: "Finndu betra veður í nágrenninu",
    landingScreenshot2Subtitle: "Sjáðu hvar aðstæður eru betri í nágrenninu í stað þess að giska.",
    landingScreenshot3Title: "Ákveddu hvort það borgi sig að færa sig",
    landingScreenshot3Subtitle: "Ákveddu hvort það borgar sig að færa sig áður en þú heldur áfram.",

    landingFinalEyebrow: "Ertu að fara að tjalda á Íslandi?",
    landingFinalTitle: "Finndu betra veður áður en þú ferð.",
    landingFinalText: "Sjáðu hvar er betra að vera og hvort það borgi sig að færa sig.",
    landingFinalNote: "Taktu betri ákvörðun áður en þú leggur af stað.",

    landingMockTagline: "Veður fyrir tjaldsvæði á Íslandi",
    landingMockBetterNearby: "Betra í nágrenninu",
    landingMockCurrentCampsite: "Vík tjaldsvæði",
    landingMockCurrentRegion: "Suðurland",
    landingMockScore: "Stig",
    landingMockWind: "Vindur",
    landingMockRain: "Rigning",
    landingMockTrend: "Þróun",
    landingMockTrendRough: "Róstusamt",
    landingMockRecommendationTitle1: "Betri kostur í nágrenninu",
    landingMockRecommendationTitle2: "Prófaðu þetta í staðinn",
    landingMockRecommendationTitle3: "Veðrið lítur betur út hér",
    landingMockBetterPlace: "Þakgil",
    landingMockBetterDistance: "~24 km í beinni línu",
    landingMockBenefit1: "Minni vindálag",
    landingMockBenefit2: "Minni rigning á morgun",
    landingMockBenefit3: "Betri heildaraðstæður til að tjalda",
    landingAdvisorModuleTitle: "Ferðaráðgjafi",
    landingAdvisorModuleSubtitle: "Finndu betra veður í nágrenninu áður en þú færir þig.",

    landingAdvisorBadgeStay: "Vertu áfram",
    landingAdvisorBadgeConsider: "Íhugaðu að færa þig",
    landingAdvisorBadgeMove: "Færðu þig",

    landingAdvisorStayTitle: "Vertu áfram",
    landingAdvisorStaySubtitle: "Aðstæður hér eru ásættanlegar næstu daga",
    landingAdvisorStayBenefit1: "Minni breytingar fram undan",
    landingAdvisorStayBenefit2: "Aðstæður eru viðráðanlegar",
    landingAdvisorStayBenefit3: "Enginn skýr ávinningur af því að færa sig",

    landingAdvisorConsiderTitle: "Íhugaðu að færa þig",
    landingAdvisorConsiderSubtitle: "Betri aðstæður eru í nágrenninu",
    landingAdvisorConsiderBenefit1: "Minni vindálag annars staðar",
    landingAdvisorConsiderBenefit2: "Minni rigning í nágrenninu",
    landingAdvisorConsiderBenefit3: "Getur borgað sig að færa sig",

    landingAdvisorMoveTitle: "Færðu þig",
    landingAdvisorMoveSubtitle: "Það borgar sig að færa sig miðað við aðstæður",
    landingAdvisorMoveBenefit1: "Minni vindálag",
    landingAdvisorMoveBenefit2: "Minni rigning á morgun",
    landingAdvisorMoveBenefit3: "Betri heildaraðstæður til að tjalda",
    landingAdvisorStayRisk: "Staðan núna: Viðráðanleg",
    landingAdvisorStayExtra: "Það er óþarfi að færa sig eins og er.",

    landingAdvisorConsiderRisk: "Staðan núna: Breytileg",
    landingAdvisorConsiderExtra: "Betri aðstæður eru nálægt — það gæti borgað sig að færa sig",

    landingAdvisorMoveRisk: "Áhætta á leið: Miðlungs",
    landingAdvisorMoveExtra: "Lengra stormaskeið er líklegt á Þjóðvegi 1 til Laugardal.",
    landingHeroUrgency: "Veðrið 20 mínútum í burtu getur verið allt öðruvísi.",
    landingHeroNoSignup: "Engin skráning nauðsynleg",
    landingFinalCta: "Athuga veður nálægt þér",

    comparisonSectionTitle: "Betra veður gæti verið nær en þú heldur",
    comparisonSectionSubtitle:
      "Eltum Veðrið ber saman nálæg tjaldsvæði til að hjálpa þér að finna rólegra og þægilegra veður.",
    comparisonCurrentLabel: "Núverandi tjaldsvæði",
    comparisonBetterLabel: "Nálægur valkostur",

    comparisonRowGust: "Hviður",
    comparisonRowRain: "Rigning",
    comparisonRowConditions: "Aðstæður",
    comparisonRowWarnings: "Viðvaranir",

    comparisonCurrentGust: "20 m/s",
    comparisonCurrentRain: "Mikil",
    comparisonCurrentConditions: "Erfiðar",
    comparisonCurrentWarnings: "2 virkar",

    comparisonBetterGust: "10 m/s",
    comparisonBetterRain: "Lítil",
    comparisonBetterConditions: "Viðráðanlegar",
    comparisonBetterWarnings: "Engar",

    comparisonLessWind: "Minni vindur",
    comparisonLessRain: "Minni rigning",
    comparisonBetterComfort: "Þægilegri aðstæður",
    comparisonFewerWarnings: "Færri veðurviðvaranir",
    comparisonBetterDriving: "Betri akstursaðstæður",

    campaignAvoidBadWeatherHeadline: "Forðastu versta tjaldveðrið á Íslandi",
    campaignAvoidBadWeatherSubheadline: "Berðu saman nálæg tjaldsvæði og finndu rólegri og þurrari kosti áður en þú kemur þér fyrir.",
    campaignAvoidBadWeatherCta: "Finna betra veður í nágrenninu",

    campaignCaravanWeatherHeadline: "Skipuleggðu rólegri ferð með hjólhýsi",
    campaignCaravanWeatherSubheadline: "Skoðaðu vind, vindhviður, rigningu og nálæga valkosti áður en þú leggur af stað eða kemur þér fyrir.",
    campaignCaravanWeatherCta: "Bera saman aðstæður fyrir hjólhýsi",

    campaignCampingWindHeadline: "Skoðaðu vind og vindhviður áður en þú velur tjaldsvæði",
    campaignCampingWindSubheadline: "Finndu berskjölduð tjaldsvæði og rólegri valkosti í nágrenninu fyrir tjöld, húsbíla og hjólhýsi.",
    campaignCampingWindCta: "Finna rólegri tjaldsvæði",

    campaignWeekendCampingHeadline: "Finndu betra tjaldveður fyrir helgina",
    campaignWeekendCampingSubheadline: "Berðu saman nálæg tjaldsvæði áður en þú leggur af stað svo vindur eða rigning komi síður á óvart.",
    campaignWeekendCampingCta: "Skipuleggja helgina",

    // Ticket 399 (#399) — companion values only; /en/northern-lights is
    // route-locked to English and never renders these.
    // Ticket 403 (#403): revised to match the English WHERE-to-go value
    // proposition; still unused by the (English-only) route.
    auroraLandingMetaTitle: "Hvert á að fara til að sjá norðurljósin á Íslandi í kvöld",
    auroraLandingMetaDescription:
      "Berðu saman norðurljósavirkni og skýjahulu á milli staða á Íslandi til að finna út hvert á að fara til að sjá norðurljósin í kvöld.",
    auroraLandingHeroTitle: "Finndu hvar má sjá norðurljósin á Íslandi í kvöld",
    auroraLandingHeroSubtitle:
      "Við berum saman norðurljósavirkni og skýjahulu á milli staða á Íslandi til að hjálpa þér að ákveða hvert á að fara.",
    auroraLandingValueSectionHeading: "Vittu hvert á að fara í kvöld",
    auroraLandingHowEyebrow: "Hvernig þetta virkar",
    auroraLandingHowText:
      "Núverandi skilyrði eru borin saman um allt Ísland út frá norðurljósavirkni, skýjahulu og myrkri.",
    auroraLandingDisclaimer:
      "Norðurljós eru náttúrufyrirbæri. Engin spá getur tryggt að þau sjáist.",
  },
};
